import { useContext, useMemo } from "react";
import { RightsHoldersNamesViewModel } from "../../../generated/data-contracts";
import { RightsHolderType } from "../../../models";
import { IAxiosError, TableUtils } from "../../../utils";
import { AvisSection } from "../../shared/components/form";
import { AvisSimpleTable, IColumnConfig } from "../../shared/components/table";
import { AvisContext } from "../../shared/context/AvisContext";
import { ErrorLoadingDataHoc } from "../../shared/error/ErrorLoadingDataHoc";

interface INamesGridProps {
  initData?: RightsHoldersNamesViewModel[];
  loading: boolean;
  error?: IAxiosError;
}

export function NamesGrid(props: Readonly<INamesGridProps>) {
  const { initData, loading, error } = props;
  const { res, ctxRightsHolder } = useContext(AvisContext);

  const columnMetadata: IColumnConfig[] = useMemo(() => {
    return [
      TableUtils.columnConfigString<RightsHoldersNamesViewModel>(
        "ipiNameNumber",
        res("authors_NamesPage_TableColumn_IPINumber"),
      ),
      TableUtils.columnConfigString<RightsHoldersNamesViewModel>(
        "rightsHolderNameName",
        res("authors_NamesPage_TableColumn_NameType"),
      ),
      ...(ctxRightsHolder?.rightsHolderTypeCode === RightsHolderType.Author
        ? [
            TableUtils.columnConfigString<RightsHoldersNamesViewModel>(
              "firstName",
              res("authors_NamesPage_TableColumn_FirstName"),
            ),
          ]
        : []),

      TableUtils.columnConfigString<RightsHoldersNamesViewModel>(
        "lastName",
        ctxRightsHolder?.rightsHolderTypeCode === RightsHolderType.Author
          ? res("authors_NamesPage_TableColumn_LastName")
          : res("authors_NamesPage_TableColumn_Title"),
      ),
    ];
  }, [res, ctxRightsHolder?.rightsHolderTypeCode]);
  const renderGrid = () => {
    return (
      <ErrorLoadingDataHoc error={error} loading={loading}>
        <AvisSimpleTable<RightsHoldersNamesViewModel>
          columnMetadata={columnMetadata}
          data={initData}
          mobileCellsVisible={4}
        />
      </ErrorLoadingDataHoc>
    );
  };
  return (
    <AvisSection title={res("authors_NamesPage_SectionNamesListTitle")}>
      {renderGrid()}
    </AvisSection>
  );
}
